<template>
    <div id="apprenticeMakeMoney">
        <Headers :headersText='headersText'></Headers>
        <div class="boxPadding">
            <div class="explain">
                <div class="text">
                    <div class="title">(1)收徒方式</div>
                    <div class="content">&emsp;您可通过收徒页面，分享钱大师到微信；或者保存二维码、链接发送给好友</div>
                    <div class="title">(2)收徒提成</div>
                    <div class="content">&emsp;当您收到一位徒弟后，这位徒弟完成一个任务，您就可以提成0.6元，完成两个任务您提成1.2元，依此方式累计，每位徒弟您可以收到的提成上限为10元</div>
                    <div class="title">(3)注意事项</div>                
                    <div class="content">&emsp;收徒人数无上限</div>             
                </div>

                <img src="../../assets/images/img_50.png" alt="" id="bgs">
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../../components/headers.vue'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'收徒弟赚钱',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #apprenticeMakeMoney{
        .boxPadding{
            padding: 15px;
            .explain{
                width: 345px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #DEDEDE;
                position: relative;
                .text{
                    margin: 15px 15px 25px;
                    color: #111111;
                    font-size: 13px;
                    line-height: 18px;
                    .title{
                        font-weight: bold;
                        &:not(:first-of-type){
                            margin-top: 15px;
                        }
                    }
                }
                #bgs{
                    width: 216px;
                    height: 158px;
                    position: absolute;
                    right: 20px;
                    bottom: 20px;
                }
            }
        }
    }
</style>